{
  "form": {
    "input_placeholder": "Tambahkan tugas…",
    "parseWithAi_aria": "Uraikan tugas dengan AI",
    "parseWithAi_title": "Rapikan dan tetapkan prioritas dengan AI",
    "priorityLabel_aria": "Prioritas tugas",
    "add": "Tambah",
    "signInForAi": "Masuk untuk menggunakan fitur AI.",
    "aiUnavailable": "AI tidak tersedia. Coba lagi.",
    "saveTo": "Simpan ke",
    "saveTo_aria": "Simpan ke {{list}}",
    "saveToSynced_aria": "Simpan ke {{list}}, {{provider}}",
    "addedTo": "Ditambahkan ke {{list}}",
    "addedToSynced": "Ditambahkan ke {{list}} · {{provider}}",
    "show": "Tampilkan"
  },
  "priority": {
    "Critical": "Kritis",
    "High": "Tinggi",
    "Medium": "Sedang",
    "Low": "Rendah"
  },
  "item": {
    "edit_aria": "Edit tugas",
    "delete_aria": "Hapus tugas",
    "addStep": "Tambah langkah",
    "addStep_placeholder": "Tambah langkah…",
    "addStep_aria": "Tambah langkah ke {{task}}",
    "steps_group_aria": "Langkah-langkah {{task}}",
    "steps_progress_aria": "{{done}} dari {{count}} langkah selesai",
    "completeSteps_aria": "{{task}}. Juga menyelesaikan {{count}} langkah yang belum selesai"
  },
  "list": {
    "title": "Tugas",
    "newListFallback": "Daftar Baru",
    "completedMeta": "{{completed}} dari {{total}} selesai",
    "deleteConfirm": "Hapus \"{{name}}\"?",
    "rename_title": "Ganti nama",
    "deleteList_title": "Hapus daftar",
    "newListName_placeholder": "Nama daftar…",
    "newList": "Daftar baru",
    "done": "Selesai",
    "emptyTitle": "Belum ada tugas",
    "emptySubtitle": "Tambahkan satu di bawah untuk memulai.",
    "noFilterMatch": "Tidak ada tugas yang cocok dengan filter ini.",
    "createIn": "Buat di",
    "inDestination": "di {{destination}}",
    "createIn_aria": "Buat di {{destination}}",
    "createInAccount_aria": "Buat di {{destination}}, {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "Membuat di {{destination}}…",
    "createFailed": "Tidak dapat membuat “{{name}}” di {{destination}}.",
    "createLimit": "{{destination}} telah mencapai batas daftar.",
    "keepInRhemn": "Simpan di Rhemn"
  },
  "filter": {
    "label": "Filter",
    "all": "Semua"
  },
  "voice": {
    "mic_aria": "Tambah tugas dengan suara",
    "mic_title": "Ucapkan tugasmu — diurutkan menurut prioritas dan waktu",
    "stop_aria": "Berhenti dan urutkan tugas",
    "recording": "Merekam",
    "sorting": "Mengurutkan tugasmu…",
    "stripTitle": "Tugas yang terdengar",
    "stripCount": "{{checked}} dari {{total}}",
    "discard": "Buang",
    "addN": "Tambah {{count}}",
    "addZero": "Tambah",
    "adding": "Menambahkan…",
    "parseFallback": "Tidak bisa diurutkan — kata-katamu ada di kolom.",
    "nothingHeard": "Tidak terdengar — coba lagi.",
    "micDenied": "Mikrofon diblokir — izinkan di pengaturan.",
    "gateBody": "Ucapkan tugasmu — diurutkan menurut prioritas dan blok salat. Termasuk dalam Pro.",
    "listen_aria": "Mendengarkan — ucapkan tugasmu"
  }
}
